import React, { useContext, useEffect, useState } from 'react'
import { Text, View, ScrollView, Platform } from 'react-native'
import { TemplatePage } from '../../components/TemplatePage'
import { ChangeLanguage } from '../../components/ChangeLanguage'
import { styles } from './styles'
import { useAreaSelector } from './hooks/useAreaSelector'
import { Card } from './components/Card'
import { Alert401 } from '../../components/AlertMessage/Alert401'
import {
  AquaIcon,
  HealthIcon,
  Rectangle,
  SeaWaterIcon,
  SweetWaterIcon,
  TruckIcon,
} from '../../components/Svg'
import { LogoutBigIcon } from '../../components/LogoutBigIcon/LogoutBigIcon'
import { AuthContext } from '../../context/Auth/AuthContext'

export const AreaSelectorScreen = () => {
  const {
    handleLogOut,
    handelSelectedArea,
    freshWaterData,
    seaWaterData,
    t,
    user,
    controlServiceData,
    necropsyData,
    fuelData,
  } = useAreaSelector()
  const { getTokenUrl, tokenType } = useContext(AuthContext)
  const [redirected, setRedirected] = useState(false)
  const areas = [...new Set(user.permissions?.map((permission) => permission.path.split('/')[0]))]

  const areasMap: { [key: string]: React.JSX.Element } = {
    sweetWater: (
      <Card
        key='sweetWater'
        isLoading={freshWaterData.isLoading}
        onPress={() => handelSelectedArea('sweetWater')}
        title='AGUA DULCE'
        icon={() => <SweetWaterIcon />}
      />
    ),

    seaWater: (
      <Card
        key='seaWater'
        isLoading={seaWaterData.isLoading || controlServiceData.isLoading}
        onPress={() => handelSelectedArea('seaWater')}
        title='AGUA MAR'
        icon={() => <SeaWaterIcon />}
      />
    ),

    health: (
      <Card
        key='health'
        isLoading={necropsyData.isLoading}
        onPress={() => handelSelectedArea('health')}
        title='SALUD'
        icon={() => <HealthIcon />}
      />
    ),
    logistic: (
      <Card
        key='logistic'
        isLoading={fuelData.isLoading}
        onPress={() => handelSelectedArea('logistic')}
        title='LOGISTICA'
        icon={() => <TruckIcon width={40} height={41} />}
      />
    ),
  }

  useEffect(() => {
    if (
      areas.find((area) => area === 'seaWater') &&
      tokenType === 'url' &&
      !redirected &&
      getTokenUrl &&
      Platform.OS === 'web'
    ) {
      handelSelectedArea('seaWater')
      setRedirected(true)
    }
  }, [user])

  return (
    <TemplatePage styleContent={{ padding: 0 }}>
      <LogoutBigIcon backButton={false} notificationsHeader />
      <ScrollView style={{ paddingHorizontal: 32 }}>
        <Alert401
          isRender={
            seaWaterData.codeError === 401 ||
            freshWaterData.codeError === 401 ||
            controlServiceData.codeError === 401 ||
            necropsyData.codeError === 401 ||
            fuelData.codeError === 401
          }
          action={handleLogOut}
        />

        <Text style={styles.welcome}>{t('BIENVENIDO')}</Text>

        {user.assignedAreas === 1 && areasMap[user.areaSelected!]}

        {(user.areaSelected === null || user.assignedAreas! > 1) && (
          <>
            <View style={{ justifyContent: 'center', alignItems: 'center' }}>
              <Rectangle />
              <Text style={styles.text}>{t('Selecciona un área a monitorear')}</Text>
            </View>
            {areas.map((area) => areasMap[area!])}
          </>
        )}
        <View style={{ alignItems: 'center' }}>
          <AquaIcon />
        </View>
        <ChangeLanguage />
      </ScrollView>
    </TemplatePage>
  )
}
